<kui-modal #modal
    [title]="'DIALOG.CONFIRMATION' | translate"
    [actions]="modalActions"
    (onClose)="detachModal()">
    <div class="p-4">
        {{ data.message }}
    </div>
</kui-modal>